import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { MAIN_COLORS } from '../../consts/colors'

interface IProps{
    children: string | ReactNode
    onClick:()=>void
    style?: any
    color?: string,
    copyButton?: boolean 
}

const Button = styled.button<{$color?:string, $copyButton?: boolean}>`
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 12px;
    border: 2px solid ${props => props.$color ? props.$color : MAIN_COLORS.pink};
    border-radius: 10px;
    color: ${props => props.$color ? props.$color : MAIN_COLORS.pink};

    &:active {
        background-color: ${MAIN_COLORS.purple_300};
    }

    ${p => p.$copyButton && `
        background: ${MAIN_COLORS.purple_500};
        color:#FFFFFF;
        border: none;
    `}
`

const MainButton:FC<IProps> = ({ children, onClick, color, copyButton, style }) => {
  return (
        <Button $copyButton={copyButton} onClick={onClick} $color={color} style={{...style }}>
            <h2>{children}</h2>
        </Button>
  )
}

export default MainButton
